import { createContext } from 'react'

/**
 * Resolves a directly-`<img>`-usable src for a mini-app's server-composited icon
 * PNG (custom image background / uploaded foreground). Two implementations wrap
 * their trees:
 *   - main SPA → credentialed `fetch` of `/api/miniapp/:id/icon.png` → objectURL
 *     (the `-api` origin is cross-site; a plain <img src> wouldn't send the
 *     session cookie, so we fetch with credentials like every other API call).
 *   - share-view → the path-authed `/s/<sid>/_papan/icon-<rev>-<size>.png` URL,
 *     usable directly as an <img src> (the session is in the path, no cookie).
 *
 * `null` (the default, no provider) → `MiniappIcon` renders a spec-only placeholder
 * (background + no glyph) so nothing breaks on surfaces that don't provide one.
 */
export interface IconAssetUrlResolver {
  /** Return a directly-usable <img> src for the icon PNG, or null if unavailable. */
  load(refId: string, rev: string, sizePx: number): Promise<string | null>
}

export const IconAssetUrlContext = createContext<IconAssetUrlResolver | null>(null)
